export const REFERRAL_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/
export const REFERRAL_SLUG_MAX_LENGTH = 64

export function normalizeReferralSlug (value: unknown): string | null {
  if (typeof value !== 'string') {
    return null
  }

  const slug = value.trim().toLowerCase()
  if (!slug || slug.length > REFERRAL_SLUG_MAX_LENGTH || !REFERRAL_SLUG_PATTERN.test(slug)) {
    return null
  }

  return slug
}

export function chooseFirstReferralSlug (existing: unknown, incoming: unknown): string | null {
  return normalizeReferralSlug(existing) || normalizeReferralSlug(incoming)
}
